.select-plan-button {
  grid-row: var(--lineup-plan-grid-row-select-plan-button);
}

.selected-label {
  grid-row: var(--lineup-plan-grid-row-select-plan-button);
  color: var(--blue-600);
  margin: auto;
  text-align: center;
}
